import type { RouteSeo } from '../../../../shared/seo/types';
import { CUSTOMER_CARE_EMAIL, CUSTOMER_CARE_PHONE } from '@/shared/constants/contact';

export const homeSeo: RouteSeo = {
  title:
    'BlueStone Online Jewellery Shopping Store - Buy Gold & Diamond Jewellery Designs In India',
  description:
    'Discover the latest gold and diamond jewellery designs at BlueStone.com. Shop online for exquisite rings, pendants, earrings, mangalsutras, and more. Enjoy ✓ Certified Jewellery ✓ Money Back ✓ COD, ✓ Free Shipping and a ✓Lifetime Exchange Policy.',
  canonical: 'https://www.bluestone.com',
  robots: 'index, follow',
  meta: [
    { property: 'og:site_name', content: 'BlueStone' },
    { property: 'og:url', content: 'https://www.bluestone.com' },
    {
      property: 'og:image',
      content:
        'https://kinclimg5.bluestone.com/f_webp/static/resources/themes/bluestone/images/new/bs-logo-2x.png',
    },
    {
      property: 'og:title',
      content:
        'BlueStone Online Jewellery Shopping Store - Buy Gold and Diamond Jewellery with Latest Designs In India',
    },
    {
      property: 'og:description',
      content:
        'Discover the latest gold and diamond jewellery designs at BlueStone.com. Shop online for exquisite rings, pendants, earrings, mangalsutras, and more. Enjoy ✓ Certified ✓ Money Back ✓ COD, ✓ Free Shipping and a ✓lifetime exchange policy.',
    },
    { name: 'twitter:card', content: 'Summary' },
    { name: 'twitter:site', content: '@bluestone_com' },
    {
      name: 'twitter:image',
      content:
        'https://kinclimg5.bluestone.com/f_webp/static/resources/themes/bluestone/images/new/bs-logo-2x.png',
    },
    {
      name: 'twitter:title',
      content:
        'BlueStone Online Jewellery Shopping Store - Buy Gold and Diamond Jewellery with Latest Designs In India',
    },
    {
      property: 'twitter:description',
      content:
        'Discover the latest gold and diamond jewellery designs at BlueStone.com. Shop online for exquisite rings, pendants, earrings, mangalsutras, and more. Enjoy ✓ Certified ✓ Money Back ✓ COD, ✓ Free Shipping and a ✓lifetime exchange policy.',
    },
    { name: 'twitter:url', content: 'https://www.bluestone.com' },
  ],
  jsonLd: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Bluestone.com',
    url: 'https://www.bluestone.com',
    logo: 'https://kinclimg5.bluestone.com/f_webp/static/resources/themes/bluestone/images/new/bs-logo-2x.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: CUSTOMER_CARE_PHONE,
      email: CUSTOMER_CARE_EMAIL,
      contactType: 'customer service',
    },
    sameAs: [
      'https://www.facebook.com/bluestonejewels',
      'https://www.instagram.com/bluestone_jewellery/',
      'https://www.youtube.com/user/Bluestonedotcom',
      'https://twitter.com/bluestone_com',
      'https://in.pinterest.com/bluestonejewellery/',
    ],
  },
};

